export default __webpack_public_path__ + "static/media/cover-with-bg-mobile.c518cb0e.webp";